// copy of the logo URL in packages/integrations/snowflake/shared/src/registry.ts
/** Snowflake's logo URL. Kept separate from `snowflake-ai`'s registration so
 * the MCP server spec can use it without registering the integration. */
export const SnowflakeAiIconUrl =
  "https://avatars.githubusercontent.com/u/6453780?s=200&v=4";
